import { FileText, Clock, Zap } from 'lucide-react';

type WorkflowType = 'APPLICATION_REQUIRED' | 'IMMEDIATE' | 'QUOTE_REQUIRED';

interface WorkflowTypeSelectorProps {
  current: WorkflowType;
  onSelect: (type: WorkflowType) => void;
}

export function WorkflowTypeSelector({ current, onSelect }: WorkflowTypeSelectorProps) {
  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">Type de workflow</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <WorkflowCard 
          id="APPLICATION_REQUIRED" label="Sur demande" desc="Validation manuelle par votre équipe" 
          icon={FileText} active={current === 'APPLICATION_REQUIRED'} onClick={onSelect} 
        />
        <WorkflowCard 
          id="QUOTE_REQUIRED" label="Devis obligatoire" desc="Devis personnalisé envoyé au client" 
          icon={Clock} active={current === 'QUOTE_REQUIRED'} onClick={onSelect} 
        />
        <WorkflowCard 
          id="IMMEDIATE" label="Paiement immédiat" desc="Réservation et paiement instantanés" 
          icon={Zap} active={current === 'IMMEDIATE'} onClick={onSelect} 
        />
      </div>
    </div>
  );
}

function WorkflowCard({ id, label, desc, icon: Icon, active, onClick }: any) {
  return (
    <button
      type="button"
      onClick={() => onClick(id)}
      className={`relative p-6 rounded-xl border-2 transition-all text-left ${active ? 'border-[#00758d] bg-[#00758d]/5 shadow-lg scale-105' : 'border-gray-200 hover:border-gray-300 hover:shadow-md'}`}
    >
      {active && <div className="absolute top-3 right-3 w-6 h-6 bg-[#00758d] rounded-full flex items-center justify-center"><svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" /></svg></div>}
      <div className={`w-14 h-14 rounded-xl flex items-center justify-center mb-4 ${active ? 'bg-[#00758d]' : 'bg-gray-100'}`}><Icon className={`w-7 h-7 ${active ? 'text-white' : 'text-gray-600'}`} /></div>
      <h4 className="text-base font-bold text-gray-900 mb-2">{label}</h4>
      <p className="text-sm text-gray-600 leading-relaxed">{desc}</p>
    </button>
  );
}
